<template>
  <div class="signature">
    <div class="topInfo">
      <div class="contentInfo">
        <el-row>
          <el-col :span="12" v-loading="person.loading">
            <div class="left">
              <div class="company">{{ person.accountName }}</div>
              <div v-if="person.approveStatus === '02'" class="unauth_info">
                你已完成实名认证，可进行电子印章签署
              </div>
              <template v-else>
                <div v-if="person.approveStatus === '03'" class="unauth_info">
                  请重新认证
                </div>
                <div v-else class="unauth_info">该用户暂未认证</div>
                <el-button
                  type="text"
                  class="unauth_btn"
                  @click="initPersonDialog"
                  >立即认证</el-button
                >
              </template>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="right" v-loading="company.loading">
              <div class="bigTitle">{{ company.name }}</div>
              <ul v-if="company.approveStatus === '02'" class="auth_ul">
                <li class="li">
                  <p class="label">企业成员</p>
                  <p v-if="!person.accountType.includes('03')" class="value">
                    {{ company.personCount || 0 }}
                  </p>
                  <p v-else class="value jump" @click="showMemberList">
                    {{ company.personCount || 0 }}
                  </p>
                </li>
                <li class="li">
                  <p class="label">印章管理</p>
                  <p v-if="!person.accountType.includes('03')" class="value">
                    {{ company.sealCount || 0 }}
                  </p>
                  <p v-else class="value jump" @click="showManagementList">
                    {{ company.sealCount || 0 }}
                  </p>
                </li>
                <li class="li">
                  <p class="label">已签署</p>
                  <!-- <p v-if="!person.accountType.includes('03')" class="value">{{ company.hasSignCount || 0 }}</p> -->
                  <p class="value">{{ company.hasSignCount || 0 }}</p>
                </li>
                <li class="li">
                  <p class="label">待签署</p>
                  <!-- <p v-if="!person.accountType.includes('03')" class="value">{{ company.toSignCount || 0 }}</p> -->
                  <p class="value">{{ company.toSignCount || 0 }}</p>
                </li>
                <li class="clear"></li>
              </ul>
              <div v-else class="unAuth_manage" style="margin-top: 10px">
                <!-- <i class="el-icon-unAuth"></i> -->
                <div v-if="company.approveStatus === '03'" class="message">
                  <i class="el-icon-unAuth"></i>请重新认证
                </div>
                <div v-else class="message">
                  <i style="color: #e21010" class="el-icon-unAuth"></i>
                  该企业暂未认证
                </div>
                <el-button
                  type="text"
                  class="unauth_btn"
                  @click="initCompanyDialog"
                  >立即认证</el-button
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-divider />
    <ab-list-query
      :tabs="tabs"
      style="margin-top: 4px"
      @handleTabs="handleTabs"
      :isActive="activeName"
      :showToolbar="activeName != 'wait'"
    >
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              size="mini"
              placeholder="单据编号/订单编号"
              v-model.trim="formSearch.customerBillNumber"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select
              size="mini"
              v-model="formSearch.bizType"
              @change="searchForm"
              placeholder="业务类型"
              clearable
            >
              <el-option
                v-for="(option, idx) in bizTypes"
                :key="idx"
                :label="option.name"
                :value="option.number"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="4">
            <el-select
              size="mini"
              v-model="formSearch.billType"
              @change="searchForm"
              placeholder="签署主题"
              clearable
            >
              <el-option
                v-for="(option, idx) in billTypes"
                :key="idx"
                :label="option.desc"
                :value="option.value"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="4" v-if="activeName === 'already'">
            <el-select
              size="mini"
              placeholder="签署状态"
              @change="searchForm"
              v-model="formSearch.taskStatus"
              clearable
            >
              <!-- <el-option :value="1" label="待签署"></el-option> -->
              <el-option :value="2" label="签署完成"></el-option>
              <el-option :value="3" label="签署失败"></el-option>
              <el-option :value="4" label="拒签"></el-option>
              <el-option :value="5" label="已作废"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <ab-timeSearch
                class="searchBox"
                :startSrc="activeName === 'wait' ? '发送日期起' : '签署日期起'"
                :endSrc="activeName === 'wait' ? '发送日期止' : '签署日期止'"
                v-model="formSearch.timeRange"
                @searchEvent="searchForm"
            ></ab-timeSearch>
          </el-col>
          <el-col :span="4" class="text-left">
            <el-button @click="searchForm">搜索</el-button>
            <el-button link class="btn-svg" @click="resetForm"
              ><ab-svg name="qingchu"></ab-svg>清除</el-button
            >
          </el-col>
        </el-row>
      </template>
      <template #toolbar>
        <el-button
          size="mini"
          type="primary"
          :loading="exportLoading"
          @click="exportFile"
          >导出</el-button
        >
      </template>
      <template #table>
        <ab-table
          class="signatureTable"
          ref="signatureTable"
          stripe
          showOrder
          showEdit
          index-label="序号"
          indexWidth="60"
          :widths="
            activeName == 'wait'
              ? `${btnLoading ? 300 : 260}`
              : `${btnLoading ? 220 : 180}`
          "
          :column-list="activeName == 'wait' ? columns : columns1"
          :table-list="tableData"
          :dataListLoading="tableLoading"
        >
          <template #sourceBillNumber="scope">
            <span
              v-if="['07', '08', '09'].includes(scope.row.billType)"
              class="font-primary"
              @click="openDetail(scope.row)"
              >{{ scope.row.sourceBillNumber }}</span
            >
            <span v-else>{{ scope.row.sourceBillNumber }}</span>
          </template>
          <template #operator="scope">
            <div class="operator">
              <el-button
              type="primary" class="is-link"
                v-if="activeName == 'wait'"
                style="color: #0b7aff"
                :loading="btnLoading"
                @click="newWindow(scope.row, '0')"
                >签章</el-button
              >
                <!-- <i class="dividingLine" v-if="activeName == 'wait'"></i> -->
              <el-button
                style="color: #0b7aff"
                type="primary" class="is-link"
                :loading="btnLoading"
                :style="activeName == 'wait'?'margin-left:10px':''"
                @click="newWindow(scope.row, '1')"
                >预览</el-button
              >
                <!-- <i class="dividingLine"></i> -->
              <el-button
                style="color: #0b7aff; margin-left: 10px"
                type="primary" class="is-link"
                @click="downloadFile(scope.row)"
                >下载</el-button
              >
            </div>
          </template>
        </ab-table>
      </template>
      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>
    <ab-preview :preview="preview" @handleClose="handleClose">
      <template #button>
        <el-button @click="preview.show = false">关 闭</el-button>
      </template>
    </ab-preview>
    <!-- <receipt-notice-detail v-model="receiptNoticeDialog" @refresh="searchForm"></receipt-notice-detail> -->
    <acDialog :dialog="dialog"></acDialog>
  </div>
</template>

<script>
import myInvoiceDetail from "../my-account/my-invoice-detail";
import receiptNoticeDetail from "../my-account/receipt-notice-detail";
import acDialog from "./acDialog";
export default {
  name: "my-signature",
  components: {
    myInvoiceDetail,
    acDialog,
    receiptNoticeDetail,
  },
  props: {
    // isClient: {
    //   type: Boolean,
    //   default: true
    // }
  },
  data() {
    return {
      person: {
        loading: false,
        accountType: "",
      },
      // 表格数据
      tabs: [
        { name: "待签章", value: "", state: "wait" },
        { name: "已签章", value: "", state: "already" },
      ],
      tableLoading: false,
      exportLoading: false,
      btnLoading: false,
      company: {
        loading: false,
      },
      dialog: {
        show: false,
        data: {},
        rules: {
          accountName: [
            { required: true, message: "请输入姓名", trigger: "change" },
          ],
          mobile: [
            { required: true, message: "请输入手机号", trigger: "blur" },
            {
              validator: (rule, value, callback) => {
                if (/^1[0-9]{10}$/.test(value)) {
                  return callback();
                }

                return callback(new Error("请输入正确的手机号"));
              },
              trigger: "blur",
            },
          ],
          email: [
            { required: true, message: "请输入邮箱", trigger: "blur" },
            {
              validator: (rule, value, callback) => {
                if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
                  return callback();
                }

                return callback(new Error("请输入正确的邮箱地址"));
              },
              trigger: "blur",
            },
          ],
          cardNumber: [
            { required: true, message: "请输入身份证号", trigger: "blur" },
            {
              validator: (rule, value, callback) => {
                if (
                  /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(
                    value
                  )
                ) {
                  return callback();
                }

                return callback(new Error("请输入正确的身份证号码"));
              },
              trigger: "blur",
            },
          ],
          name: [{ required: true, message: "请输入名称", trigger: "change" }],
          uscCode: [
            { required: true, message: "请输入社会信用代码", trigger: "blur" },
          ],
        },
      },
      userInfo: this.$utils.getSessionStorage("userInfo"),
      routeQuery: {},
      // 分页数据
      page: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0,
      },
      columns: [
        {
          props: "customerBillNumber",
          labels: "订单编号",
          widths: 100,
        },
        {
          props: "sourceBillNumber",
          labels: "来源单据号",
          widths: 100,
          slot: "slot",
        },
        {
          props: "billTypeDesc",
          labels: "签署主题",
          widths: 80,
        },
        {
          props: "bizTypeDesc",
          labels: "业务类型",
          widths: 80,
        },
        {
          props: "sourceBillTypeDesc",
          labels: "来源单据",
          widths: 100,
        },
        {
          props: "submitManIdDesc",
          labels: "发送人",
          widths: 100,
        },
        {
          props: "createTime",
          labels: "发送时间",
          widths: 110,
        },
      ],
      tableData: [],
      // 分页数据
      preview: {
        show: false,
        isView: false,
        isFooter: true,
        fileUrl: "",
      },

      columns1: [
        {
          props: "customerBillNumber",
          labels: "订单编号",
          widths: 100,
        },
        {
          props: "createTime",
          labels: "签署时间",
          widths: 130,
        },
        {
          props: "taskStatusDesc",
          labels: "签署状态",
          widths: 80,
        },
        {
          props: "billTypeDesc",
          labels: "签署主题",
          widths: 100,
        },
        {
          props: "bizTypeDesc",
          labels: "业务类型",
          widths: 80,
        },
        {
          props: "sourceBillTypeDesc",
          labels: "来源单据",
          widths: 150,
        },
        {
          props: "sourceBillNumber",
          labels: "来源单据号",
          widths: 150,
          slot: "slot",
        },
        {
          props: "description",
          labels: "签署意见",
          widths: 80,
        },
      ],

      formSearch: {},

      // tab标识
      activeName: "wait",

      // 业务类型
      bizTypes: [],
      // 签署主题
      billTypes: [],

      routeQuery: {},

      // 收款通知书弹窗
      receiptNoticeDialog: {
        show: false,
        id: "",
      },

      // 发票弹窗
      invoiceDialog: {
        show: false,
        id: "",
      },
    };
  },
  created() {
    // 动态加载组件 [商务端和客户端需引入的组件不同]
    // if (this.isClient) { // 客户端
    //   Vue.component('receipt-notice-detail', resolve => require(['../my-account/receipt-notice-detail'], resolve))
    // } else {
    //   Vue.component('receipt-notice-detail', resolve => require(['../../../fms/modules/import-bill/receipt-notice-detail'], resolve))
    // }
  },
  mounted() {
    // 临时修改
    this.routeQuery = Object.keys(this.$route.query).length
      ? this.$route.query
      : this.routeQuery;
    if (!this.userInfo) {
      this.$initSessionStorageData.getUserInfo().then(() => {
        this.userInfo = this.$utils.getSessionStorage("userInfo");
        this.initPersonBlock();
        this.initCompanyBlock();
      });
    } else {
      this.initPersonBlock();

      this.initCompanyBlock();
    }
    this.$post("/bas/basBizType/list", {bizTypeGroup: "01,02", notNumbers: ['06']}).then(({ data }) => {
      if (data.code === "C0000") {
        this.bizTypes = data.result.list;
      }
    });

    this.$post("/sys/esignFlow/billType").then(({ data }) => {
      if (data.code === "C0000") {
        this.billTypes = data.result;
      }
    });

    this.routeQuery = Object.keys(this.$route.query).length
      ? this.$route.query
      : this.routeQuery;
    if (this.routeQuery.activeName) {
      this.activeName = this.routeQuery.activeName;
    }
    this.searchForm();
  },
  activated() {
    this.routeQuery = Object.keys(this.$route.query).length
      ? this.$route.query
      : this.routeQuery;
    if (this.routeQuery.activeName) {
      this.activeName = this.routeQuery.activeName;
    }
    this.searchForm();
    this.initPersonBlock();

    this.initCompanyBlock();
    if (this.routeQuery.type == '01') {
      setTimeout(() => {
        this.initPersonDialog()
      }, 1500)
    }
  },
  methods: {
    showManagementList () {
        this.$router.push({
          path: '/managementList'
        })
    },
    resetForm() {
      this.formSearch = {};
    },
    initPersonBlock() {
      // 用户认证信息
      this.person.loading = true;
      return this.$get("/sys/esignAccount/queryAccountInfo")
        .then((res) => {
          if (res.data.code === "C0000") {
            if (res.data.result) {
              this.person = res.data.result;
            } else {
              this.person.accountName = this.userInfo.realName;
            }
          } else {
            this.$message.error(res.data.message);
            this.person.accountName = this.userInfo.realName;
          }
        })
        .catch((err) => {
          this.person.accountName = this.userInfo.realName;
          this.$message.error("服务器正忙，请稍后再试");
        })
        .finally(() => {
          this.person.loading = false;
        });
    },
    initCompanyBlock() {
      // 企业认证信息
      this.company.loading = true;
      return this.$get("/sys/esignEnterprise/queryEnterpriseInfo")
        .then((res) => {
          if (res.data.code === "C0000") {
            let result = res.data.result;
            if (result) {
              this.company = result;
            } else {
              this.company.name = this.userInfo.companyName;
            }
          } else {
            this.$message.error(res.data.message);
            this.company.name = this.userInfo.companyName;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("服务器正忙，请稍后再试");
        })
        .finally(() => {
          this.company.loading = false;
        });
    },
    initPersonDialog() {
      this.initPersonBlock().then(() => {
        if (this.person.approveStatus !== "02") {
          this.dialog.data = {
            accountName: this.person.accountName,
            mobile: this.userInfo.loginAccount.mobile,
            email: this.userInfo.loginAccount.email,
            cardNumber: "",
            isCustomerRegister: this.userInfo.isCustomerRegister,
          };
          this.dialog.url = "/sys/esignAccount/add";
          this.dialog.type = "person";
          this.dialog.title = "个人信息";
          this.dialog.show = true;
        } else {
          this.$message.success("当前账号已认证");
        }
      });
    },
    initCompanyDialog() {
      this.initCompanyBlock().then(() => {
        if (this.company.approveStatus !== "02") {
          this.dialog.type = "company";
          this.dialog.data = {
            name: this.company.name,
            uscCode: "",
          };
          this.dialog.url = "/sys/esignEnterprise/add";
          this.dialog.title = "企业信息";
          this.dialog.show = true;
        } else {
          this.$message.success("当前企业已认证");
        }
      });
    },
    showMemberList() {
      if (this.routeQuery.isIframe) {
        window.parent.postMessage(
          {
            title: "create",
            path: "/member-list",
          },
          "*"
        );
      } else {
        this.$router.push({
          path: "/member-list",
        });
      }
    },
    showManagementList() {
      if (this.routeQuery.isIframe) {
        window.parent.postMessage(
          {
            title: "create",
            path: "/managementList",
          },
          "*"
        );
      } else {
        this.$router.push({
          path: "/managementList",
        });
      }
    },
    showSealList(activeName) {
      if (this.routeQuery.isIframe) {
        window.parent.postMessage(
          {
            title: "create",
            path: "/seal-list",
            query: {
              activeName,
            },
          },
          "*"
        );
      } else {
        this.$router.push({
          path: "/seal-list",
          query: {
            activeName,
          },
        });
      }
    },

    exportFile() {
      this.exportLoading = true;
      let data = Object.assign({}, this.formSearch, { viewFlag: 1 });
      this.$post("/sys/esignTask/expList", {
        data,
        excelField: this.columns1.map((column) => {
          return column.props;
        }),
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      })
        .then(({ data }) => {
          if (data.code === "C0000") {
            // 创建隐藏的可下载链接
            var eleLink = document.createElement("a");
            eleLink.download = "";
            eleLink.style.display = "none";
            // 字符内容转变成blob地址
            eleLink.href = data.result;
            // 触发点击
            document.body.appendChild(eleLink);
            eleLink.click();
            // 然后移除
            document.body.removeChild(eleLink);
          }
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    pageSearch(obj) {
      this.page.currentPage = obj.currentPage;
      this.page.pageSize = obj.pageSize;
      this.searchForm();
    },
    localSearch() {
      this.page.currentPage = 1;
      this.searchForm();
    },
    handleTabs(item) {
      this.activeName = item;
      this.initPersonBlock();
      this.initCompanyBlock();
      this.localSearch();
    },
    searchForm() {
      let data = Object.assign({}, this.formSearch, {
        viewFlag: this.activeName == "wait" ? 0 : 1,
      });
      if (data.timeRange && data.timeRange.length) {
        data.beginSignDate = this.activeName == "wait" ? "" : data.timeRange[0];
        data.endSignDate = this.activeName == "wait" ? "" : data.timeRange[1];
        data.beginCreateDate =
          this.activeName == "already" ? "" : data.timeRange[0];
        data.endCreateDate =
          this.activeName == "already" ? "" : data.timeRange[1];
      }
      this.tableLoading = true;
      this.$post("/sys/esignTask/list", {
        data,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        isPage: this.activeName != "wait",
      })
        .then(({ data }) => {
          if (data.code === "C0000") {
            this.tableData = data.result.list;
            this.page.total = data.result.total;
            this.tabs[0].value = data.extra ? data.extra[0] || 0 : 0
          } else {
            this.$message.error(data.message);
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleClose() {
      this.localSearch();
    },
    newWindow(row, urlType) {
      this.btnLoading = true;
      let params =
        this.activeName == "wait"
          ? { id: row.id, flowId: row.flowId, urlType }
          : { flowId: row.flowId, urlType };
      this.$get("/sys/esignTask/getFlowUrl", params)
        .then(({ data }) => {
          if (data.code === "C0000") {
            if (this.activeName == "wait") {
              this.preview.isView = true;
              this.preview.fileTitle = row.billTypeDesc;
              this.preview.fileUrl = data.result;
              this.preview.show = true;
            } else {
              window.open(data.result);
            }
          }
        })
        .finally(() => {
          this.btnLoading = false;
          this.localSearch();
        });
    },
    downloadFile(row) {
      window.open(row.sourceFileUrl);
      this.localSearch();
    },
    openDetail(row) {
      if (row.billType === "07") {
        // 收款通知书
        this.receiptNoticeDialog.id = row.sourceBillId;
        this.receiptNoticeDialog.show = true;
      } else if (row.billType === "08") {
        // 进口对账单
        this.$router.push({
          //   path: this.isClient ? '/my-account/import-statement-detail' : '/import-bill/import-statement-detail',
          path: "/import-statement-detail",
          query: {
            id: row.sourceBillId,
            cache: false,
          },
        });
      } else {
        // 发票
        // if (this.isClient) {
        //   this.invoiceDialog.id = row.sourceBillId
        //   this.invoiceDialog.show = true
        // } else {
        this.$router.push({
          path: "/invoice-detail",
          query: {
            action: "detail",
            id: row.sourceBillId,
            cache: false,
          },
        });
        // }
      }
    },
  },
};
</script>

<style lang="scss">
.signature {
    border-radius: 8px;
    .detail_content{
        border-radius: 8px 8px 0 0;
      }
  .el-divider {
    border-color: #f0f2f5;
    margin: 19px 0 0;
  }
  .dividingLine {
    display: inline-block;
    width: 1px;
    height: 10px;
    background-color: #bfbfbf;
    margin: 0 5px;
  }
  .topInfo {
    margin-bottom: 10px;
    .contentInfo {
      width: 100%;
      .el-row {
        .unauth_btn {
          text-align: center;
          position: absolute;
          top: 42px;
          right: 40px;
          width: 95px;
          height: 45px;
          line-height: 45px;
          font-size: 14px;
          font-family: PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
          font-weight: 400;
          color: #fff;
          background-color: #0a7cff;
          &:hover {
            opacity: 0.6;
          }
        }
        .el-col {
          &:nth-child(1){
            padding: 20px 10px 0px 20px;
          }
          &:nth-child(2){
            padding: 20px 20px 0px 10px;
          }
          .left {
            height: 128px;
            border-radius: 16px;
            background-color: #f3f8fc;
            position: relative;
            .company {
              position: absolute;
              height: 22px;
              line-height: 22px;
              top: 32px;
              left: 40px;
              font-size: 22px;
              font-family: PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
              font-weight: bold;
              color: #000000;
            }
            .unauth_info {
              position: absolute;
              left: 40px;
              bottom: 38px;
              font-size: 14px;
              color: #636871;
            }
          }
          .right {
            padding: 25px 40px;
            height: 128px;
            border-radius: 16px;
            background-color: #f3f8fc;
            position: relative;
            .bigTitle {
              height: 22px;
              font-size: 22px;
              font-family: PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
              font-weight: bold;
              color: #162232;
            }
            .unauth_span {
              padding: 0;
              cursor: pointer;
              &:hover {
                opacity: 0.7;
              }
            }
            .message {
              position: absolute;
              left: 40px;
              bottom: 38px;
              font-size: 14px;
              color: #636871;
            }
            .auth_ul {
              width: calc(100% - 150px);
              position: absolute;
              bottom: 16px;
              .li {
                float: left;
                width: 25%;
                .label {
                  color: #636871;
                  font-size: 14px;
                }
                .value {
                  font-size: 24px;
                  font-family: DIN;
                  font-weight: 500;
                }
                .jump {
                  cursor: pointer;
                }
              }
              .clear {
                clear: both;
              }
            }
          }
        }
      }
    }
  }
  .content {
    margin-top: 8px;
    // padding: 10px 30px;
    background: #fff;
  }
}
</style>
